<template>
    <div>
        <navbar></navbar>
        <div class="container is-fullheight hero-body">
            <div class="columns is-centered">
                <div class="column is-6">
                    <login-logo></login-logo>
                </div>
                </div>
                <div class="columns is-centered">
                <div class="column is-6">
                    <div class="columns">
                        <div class="column is-12">
                            <b-tabs v-model="activeTab" position="is-centered" size="is-large">
                                <b-tab-item label="Registration Form">

                                    <b-field label="Your Name">
                                        <b-input placeholder="Your Name" v-model="nameSurname"></b-input>
                                    </b-field>
                                    <b-field label="Your e-mail" :type="registrationEmailDanger" :message="registrationEmailMessage">
                                        <b-input placeholder="Your e-mail" type="email" v-model="email"></b-input>
                                    </b-field>
                                    <b-field label="Your password">
                                        <b-input placeholder="Your password" type="password" v-model="password" password-reveal></b-input>
                                    </b-field>
                                    <b-field label="Your password again" :type="duplicatePasswordDanger" :message="duplicatePasswordMessage">
                                        <b-input placeholder="Your password again" type="password" v-model="passwordAgain" password-reveal></b-input>
                                    </b-field>
                                    <b-field>
                                        <b-checkbox v-model="memberCondition"></b-checkbox><a class="is-dark" @click="memberConditionModal()">I Accept the Terms of Membership</a>
                                    </b-field>
                                    <b-field>
                                        <b-checkbox v-model="marketingOperations">
                                            The normsandratios.com web site can send e-mail or SMS to me.
                                        </b-checkbox>
                                    </b-field>
                                </b-tab-item>

                            </b-tabs>

                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-12">
                            <button class="button is-dark is-large is-fullwidth" @click="doRegister()" v-bind:disabled="!memberCondition">
                                Register
                            </button>
                            <div class="column is-12 has-text-centered">
                                Are you already a member <a class="is-dark" @click="openLogin()">Click here to login</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Navbar from "./features/Navbar"
import LoginLogo from "./features/LoginLogo"
import LoginModal from "./modals/LoginModal"
import RegisterSuccess from "./RegisterSuccess"
import MemberCondition from "./modals/MemberCondition"
import axios from 'axios'
import { mapGetters , mapState} from "vuex";


export default {
    name: 'Register',
    data() {
        return {
            memberType: 0,
            hasError: false,
          activeTab: 0,
            memberCondition: false,
            marketingOperations: false,
            registrationError: false,
            registrationError_Password: false,
            registrationError_Email: false,
            nameSurname: '',
            email: '',
            password: '',
            passwordAgain: '',
        }
    },
    components: {
        Navbar,
        LoginLogo,
        LoginModal,
        MemberCondition,
        RegisterSuccess
    },
    computed: {
    isIDlabelDanger() {
        if (this.newId === "") return "is-danger";
    },
    duplicatePasswordDanger() {
        if (this.registrationError_Password) return "is-danger";
    },
    duplicatePasswordMessage() {
        if (this.registrationError_Password) return "Passwords do not match. Please try again.";
    },
    registrationEmailDanger() {
        if (this.registrationError_Email) return "is-danger";
    },
    registrationEmailMessage() {
        if (this.registrationError_Email) return "Account already exists. Please login directly.";
    },
            IDLabelMessage() {
        if (this.newId === "") return "Please enter an ID";
    }
    },
    methods: {

        mounted() {

        },
        openLogin() {
            this.$modal.open({
                parent: this,
                component: LoginModal,
                hasModalCArd: true,
                props: {
                }
            })
        },
        memberConditionModal() {
            this.$modal.open({
                parent: this,
                component: MemberCondition,
                hasModalCArd: true,
                props: {
                }
            })
        },
        successModal() {
            this.$modal.open({
                parent: this,
                component: RegisterSuccess,
                hasModalCArd: true,
                props: {
                }
            })
        },
                doRegister() {

          if( this.password != this.passwordAgain) {
          this.registrationError_Password = true
          } else {
          this.registrationError_Password = false

          }
            this.memberCondition = false;
            var URI = this.$api.REST_API + '/api/User/Register' 
                            const options = {
      headers: {'X-Token': this.$store.getters.authToken}
    };
              axios.post(URI, { email: this.email, name: this.nameSurname, password: this.password  },options)
                .then(({ data }) => {
                console.log("POST Response")
                console.log(data)
                      this.loading = false
                      if( data.email == this.email ) {
                        this.registrationError_Email = true
                      } else {

                      }
                      this.$router.push({ name: "RegisterSuccess" });
                      console.log("Before the success modal")
                      // successModal()

                })
                .catch((error) => {
                    this.data = []
                    this.loading = false
                    throw error
                })
        }
    }
}
</script>

<style scoped>
.why-should-i-register {
    margin-top: 20px !important;
}

.why-should-i-register-sub {
    margin-top: 10px !important;
}
.icon {
    border: 1px solid #e3e3e3 !important;
    border-radius: 100% !important;
}

.icon.is-large {
    height: 5rem !important;
    width: 5rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue